/**
 * Check if the value is `calc` function or return original string
 * @param {PropertyValueProps} item
 * @param {Number | null} [index]
 * @param {Boolean} [isCalc]
 * @returns
 */
const getValueOutput = (item, index, isCalc = false) => {
  if (isCalc) {
    return `calc(${item.get("v_output")})`;
  }

  if (index || index === 0) {
    const values = /** @type {Array<PropertyValueProps>} */ (
      item.get("v_values")
    );

    return values[index].get("v_output");
  }

  return item.get("v_output");
};

export default getValueOutput;
